import { create } from 'zustand'

interface PaymentVerificationState {
  selectedPaymentId: string | null
  verificationModalOpen: boolean
  rejectionModalOpen: boolean
  setSelectedPaymentId: (id: string | null) => void
  openVerificationModal: () => void
  closeVerificationModal: () => void
  openRejectionModal: () => void
  closeRejectionModal: () => void
}

export const usePaymentVerificationStore = create<PaymentVerificationState>((set) => ({
  selectedPaymentId: null,
  verificationModalOpen: false,
  rejectionModalOpen: false,
  setSelectedPaymentId: (id) => set({ selectedPaymentId: id }),
  openVerificationModal: () => set({ verificationModalOpen: true }),
  closeVerificationModal: () => set({ verificationModalOpen: false }),
  openRejectionModal: () => set({ rejectionModalOpen: true }),
  closeRejectionModal: () => set({ rejectionModalOpen: false }),
}))
